import { baseApi } from '@shared/utils/api/configs/rtkBaseQueryDemo';

import {
  getAllClusterBills,
  getBillingInstitutions,
  getBillPdf,
  getHistoryBills,
  getManualBill,
  getOutstandingBills,
  getPaymentInfo,
  getPublicManualBill,
  getReceiptPdf,
  submitPaymentRequest,
  submitPublicPaymentRequest,
  submitReceiptEmailRequest,
} from './endpoints';
import { CLUSTER_BILLS } from './endpoints/getAllClusterBills';
import { PAYMENT_HISTORY } from './endpoints/getHistoryBills';
import { MANUAL_BILL } from './endpoints/getManualBill';
import { OUTSTANDING_BILLS } from './endpoints/getOutstandingBills';
import { PAYMENTS_INFO } from './endpoints/getPaymentInfo';
import { getPublicPaymentInfo, PAYMENTS_PUBLIC_INFO } from './endpoints/getPublicPaymentInfo';
import { getPublicReceiptPdf, PAYMENTS_PUBLIC_RECEIPT_PDF } from './endpoints/getPublicReceiptPdf';
import { PAYMENTS_RECEIPT_PDF } from './endpoints/getReceiptPdf';
import { submitPublicReceiptEmailRequest } from './endpoints/submitPublicReceiptEmailRequest';

export const paymentsApi = baseApi
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllClusterBills: getAllClusterBills(builder),
      getBillingInstitutions: getBillingInstitutions(builder),
      getBillPdf: getBillPdf(builder),
      getHistoryBills: getHistoryBills(builder),
      getManualBill: getManualBill(builder),
      getPaymentInfo: getPaymentInfo(builder),
      getPaymentOutstandingBills: getOutstandingBills(builder),
      getPublicManualBill: getPublicManualBill(builder),
      getPublicPaymentInfo: getPublicPaymentInfo(builder),
      getPublicReceiptPdf: getPublicReceiptPdf(builder),
      getReceiptPdf: getReceiptPdf(builder),
      submitPaymentRequest: submitPaymentRequest(builder),
      submitPublicPaymentRequest: submitPublicPaymentRequest(builder),
      submitPublicReceiptEmailRequest: submitPublicReceiptEmailRequest(builder),
      submitReceiptEmailRequest: submitReceiptEmailRequest(builder),
    }),
  })
  .enhanceEndpoints({
    addTagTypes: [
      CLUSTER_BILLS,
      OUTSTANDING_BILLS,
      PAYMENT_HISTORY,
      MANUAL_BILL,
      PAYMENTS_INFO,
      PAYMENTS_PUBLIC_INFO,
      PAYMENTS_RECEIPT_PDF,
      PAYMENTS_PUBLIC_RECEIPT_PDF,
    ],
  });

export const {
  useGetAllClusterBillsQuery,
  useGetBillingInstitutionsQuery,
  useGetHistoryBillsQuery,
  useGetPaymentInfoQuery,
  useGetPaymentOutstandingBillsQuery: useGetOutstandingBillsQuery,
  useLazyGetPaymentOutstandingBillsQuery,
  useGetPublicPaymentInfoQuery,
  useLazyGetBillPdfQuery,
  useLazyGetManualBillQuery,
  useLazyGetPublicManualBillQuery,
  useLazyGetPublicReceiptPdfQuery,
  useLazyGetReceiptPdfQuery,
  useSubmitPaymentRequestMutation,
  useSubmitPublicPaymentRequestMutation,
  useSubmitPublicReceiptEmailRequestMutation,
  useSubmitReceiptEmailRequestMutation,
} = paymentsApi;
